import React, { useState } from "react";
import styles from "./UniversalInput.module.scss";
import { CopyIcon } from "@src/assets/general-icons";
import { EyeHide } from "@src/assets/general-icons/EyeHide";
import { EyeShow } from "@src/assets/general-icons/EyeShow";

type UniversalInputProps = {
	placeholder: string;
	value: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	isDisabled?: boolean;
	isCopyable?: boolean;
	label?: string;
	type?: string;
	name?: string;
} & React.ComponentProps<"input">;

const UniversalInput = (props: UniversalInputProps) => {
	const { type = "text", placeholder, value, onChange, isDisabled, isCopyable, label, name, ...rest } = props;
	const [passwordVisible, setPasswordVisible] = useState(false);

	const togglePasswordVisibility = () => {
		setPasswordVisible(!passwordVisible);
	};

	const handleCopy = () => {
		navigator.clipboard.writeText(value);
	};
	return (
		<div
			className={styles.inputWrapper}
			style={{
				pointerEvents: isDisabled ? "none" : "auto",
				opacity: isDisabled ? 0.5 : 1,
			}}>
			{label && <div className={styles.label}>{label}</div>}
			<div className={styles.styledInput} data-is-disabled={isDisabled}>
				<input
					type={type === "password" && passwordVisible ? "text" : type}
					placeholder={placeholder}
					value={value}
					name={name}
					onChange={onChange}
					disabled={isDisabled}
					className={styles.input}
					{...rest}
				/>
				{/* Show eye icon if type is password */}
				{type === "password" && (
					<span onClick={togglePasswordVisibility} onKeyDown={() => void 0} style={{ cursor: "pointer" }}>
						{passwordVisible ? <EyeHide /> : <EyeShow />}
					</span>
				)}
				{isCopyable && (
					<div onClick={handleCopy} onKeyDown={() => void 0} style={{ cursor: "pointer" }}>
						<CopyIcon />
					</div>
				)}
			</div>
		</div>
	);
};

export default UniversalInput;
